/**
 * App-wide date format: dd-MM-yyyy. Use these constants with the `date` pipe in
 * templates and the helpers below wherever a string is built in TypeScript, so
 * the whole backoffice reads the same and no screen drifts back to ISO.
 */
export const DATE_FORMAT = 'dd-MM-yyyy';
export const DATE_TIME_FORMAT = 'dd-MM-yyyy HH:mm';

/** Formats an ISO date ("2026-07-26" or a full timestamp) as "26-07-2026". */
export function fmtDate(value: string | Date | null | undefined): string {
	if (!value) {
		return '';
	}
	if (typeof value === 'string') {
		// Plain "yyyy-MM-dd" is reordered as text: parsing it as a Date would
		// shift the day in negative timezones.
		const iso = value.slice(0, 10).split('-');
		if (iso.length === 3 && iso[0].length === 4) {
			const [y, m, d] = iso;
			return `${d}-${m}-${y}`;
		}
	}
	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) {
		return typeof value === 'string' ? value : '';
	}
	return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
}

/** Same as `fmtDate` plus "HH:mm" ("26-07-2026 20:15"). */
export function fmtDateTime(value: string | Date | null | undefined): string {
	if (!value) {
		return '';
	}
	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) {
		return typeof value === 'string' ? value : '';
	}
	const time = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
	return `${fmtDate(date)} ${time}`;
}
